import { render, staticRenderFns } from "./KamiDispImage.vue?vue&type=template&id=2b875127&scoped=true&"
import script from "./KamiDispImage.vue?vue&type=script&lang=js&"
export * from "./KamiDispImage.vue?vue&type=script&lang=js&"
import style0 from "./KamiDispImage.vue?vue&type=style&index=0&id=2b875127&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b875127",
  null
  
)

export default component.exports